import React, { forwardRef } from 'react';

import { useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { TextareaAutosize } from '@material-ui/core';

import { noOp } from 'constants/helper';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const StyledTextArea = styled(TextareaAutosize)`
  padding: 10px;
  padding-left: 0px;
  border-radius: 0px;
  border: none;
  border-bottom: 1px dashed ${(props) => props.theme.colors.text.g3};

  &:hover {
    border-bottom-style: solid;
  }

  &:focus, &:focus-within, &: active {
    outline: unset;
    border-bottom: 1px solid ${(props) => props.theme.colors.primary['1565BC']};
  }

  color: ${(props) => props.theme.colors.text.g1};

  font-size: 14px;
  line-height: 20px;
  width: 100%;
  resize: none;
`;

export const MaterialUIAutoResizeTextArea = forwardRef((props, ref) => {
  const theme = useTheme();

  const { value, emptyTextValue = '-', isDisabled, isReadOnly, ...textAreaProps } = props;
  const isEmpty = !value;

  return (
    <>
      {isReadOnly ? (
        <TextBodyMedium
          ref={ref}
          color={isEmpty ? theme.colors.text.g2 : theme.colors.text.g1}
          /* conditionally handling onClick Event based on isDisabled prop */
          onClick={isDisabled ? noOp : textAreaProps?.onClick}
        >
          {isEmpty ? emptyTextValue : value}
        </TextBodyMedium>
      ) : (
        <StyledTextArea ref={ref} value={value} width="100%" minRows={1} maxRows={5} {...textAreaProps} />
      )}
    </>
  );
});
